import { useFormikContext } from "formik";
import { DatePickerSelect, Icon } from 'Components';
import Layout from "./Layout"
import { EditProfileValues } from "Pages/User/User.types";
import { useTranslation } from "react-i18next";
import ToggleButton from "Components/ToggleButton";
import Label from "./Label";
import Alert from "PhishingManager/components/Alert";
import TimePicker from "PhishingManager/components/TimePicker";
import { toMoment, toTimeString } from "../Profile.helpers";

const Notification = ({ openModal }: { openModal: () => void }) => {
	const { t } = useTranslation();
	const notificationForm = useFormikContext<EditProfileValues>();
	const { isValid, dirty, values } = notificationForm;
	const btnDisable = !(isValid && dirty);
	const disabled = !values.timezoneId;
	const { getWeeklyReport, getDeletionReport, time } = notificationForm.values.notifications || {};
	const baseTextPath = "profile.notifications";
	const dateTime = toTimeString(time);

	return <>
		{disabled && <Alert
			iconType="phishingManagerWarningModal"
			title={t(`${baseTextPath}.emailAlert.title`)}
			subtitle={t(`${baseTextPath}.emailAlert.description`)}
		/>}
		<Layout title={t(`${baseTextPath}.title`)} description={t(`${baseTextPath}.description`)} btnText={t(`saveChanges`)} handleNext={openModal} btnDisable={btnDisable}>
			<DatePickerSelect.FormikField
				label={<Label labelText={t(`${baseTextPath}.fields.weekday`)} />}
				name="notifications.day"
				placeholder={t(`${baseTextPath}.fields.dayPlaceHolder`)}
				picker="weekday"
				listHeight={200}
				disabled={disabled}
			/>

			<div className="ant-row ant-form-item toggle-btn">
				<div className="ant-col">
					<label>
						<Label labelText={t(`${baseTextPath}.fields.time`)} />
					</label>
				</div>
				<div className="ant-col">
					<TimePicker startTime={dateTime || ''} listHeight={170} suffixIcon={<Icon type="chevronDown" />} onChange={(value) => notificationForm.setFieldValue("notifications.time", toMoment(value))} />
				</div>
			</div>

			<ToggleButton
				disabled={disabled}
				prefixText={baseTextPath}
				labelText={<Label labelText={t(`${baseTextPath}.fields.getWeeklyReport`)} tooltipText={t(`${baseTextPath}.generalMailsTooltip`)} />}
				checked={!!(getWeeklyReport)}
				setChecked={(value) => notificationForm.setFieldValue("notifications.getWeeklyReport", value)}
			/>

			<ToggleButton
				disabled={disabled}
				prefixText={baseTextPath}
				labelText={<Label labelText={t(`${baseTextPath}.fields.getDeletionReport`)}
				tooltipText={t(`${baseTextPath}.manageUsersAndGroupsTooltip`)} />}
				checked={!!(getDeletionReport)}
				setChecked={(value) => notificationForm.setFieldValue("notifications.getDeletionReport", value)}
			/>
		</Layout>
	</>
}

export default Notification;